module.exports = __webpack_public_path__ + "img/Pasarelas25.89cf859e.jpg";